import React from "react";
import { Navigate, Outlet } from "react-router-dom";

// Helper function to extract a cookie by name
const getCookie = (name) => {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? decodeURIComponent(match[2]) : null;
};

const ProtectedRoute = ({ requireAdmin = false }) => {
  // Retrieve the user cookie
  const userCookie = getCookie("user");
  let user = null;

  // Parse the user data from the cookie
  if (userCookie) {
    try {
      user = JSON.parse(userCookie);
    } catch (err) {
      console.error("Error parsing user cookie:", err);
    }
  }

  // If no valid user object exists, redirect to login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // If the route requires an admin but the user isn't one, redirect to home
  if (requireAdmin && user.role !== "admin") {
    return <Navigate to="/" replace />;
  }

  // If authenticated (and authorized), render the nested child routes
  return <Outlet />;
};

export default ProtectedRoute;
